import Repository from "./Repository";

const resource = "/article";
export default {
  get() {
    return Repository.get(`${resource}`);
  }
};
